export default __webpack_public_path__ + "static/media/base-report7.9ea75aee.png";